export const SAVE_TO_RTW = 'SAVE_TO_RTW';
export const SET_RTW_STATUS = 'SET_RTW_STATUS';
export const SET_ID_CHECK_STATUS = 'SET_ID_CHECK_STATUS';
export const CLEAR_RTW = 'CLEAR_RTW';
